import { render, staticRenderFns } from "./NotesTab.vue?vue&type=template&id=77f72127&scoped=true&lang=pug&"
import script from "./NotesTab.vue?vue&type=script&lang=js&"
export * from "./NotesTab.vue?vue&type=script&lang=js&"
import style0 from "./NotesTab.vue?vue&type=style&index=0&id=77f72127&lang=stylus&scoped=true&"
import style1 from "./NotesTab.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f72127",
  null
  
)

export default component.exports